<template>
  <div
    class="chip"
    :class="{ [`chip--${$props.tag.type}`]: $props.tag.type }"
  >
    <div
      v-tooltip="tooltip"
      html-tooltip
      class="body-3 chip__content"
    >
      <div
        class="chip__text"
        v-html="$t(text)"
      />
      <the-icon
        :art="icon.art"
        :name="icon.name"
      />
    </div>
  </div>
</template>

<script setup>
  import { PRODUCT_PRICING_TAG } from '@shared/modules/COffer/constants'
  import { computed } from 'vue'

  import useI18n from '@shared/hooks/useI18n'

  // HOOKS
  const { t } = useI18n()

  // INIT
  const props = defineProps({
    label: {
      type: String,
      default: '',
    },

    tag: {
      type: Object,
      default: () => {},
    },

    tooltip: {
      type: String,
      default: '',
    },
  })

  const icon = computed(() => {
    switch (props.tag.type) {
      case PRODUCT_PRICING_TAG.DISCOUNT:
        return { art: 'light', name: 'badge-percent' }
      case PRODUCT_PRICING_TAG.IPZ:
        return { art: 'light', name: 'info-circle' }
      case PRODUCT_PRICING_TAG.CAVEAT:
      case PRODUCT_PRICING_TAG.SURCHARGE:
      default:
        return { art: 'light', name: 'circle-exclamation' }
    }
  })

  const text = computed(() => {
    return props.label || `product.tags.${props.tag.type}.text`
  })

  const tooltip = computed(() => {
    return props.tooltip || t(`product.tags.${props.tag.type}.tooltip`, { value: props.tag.value })
  })
</script>

<style scoped>
.chip {
  --dvp-tag-c-background: var(--surface);
  --dvp-tag-c-text: var(--on-surface);
}

.chip--discount {
  --dvp-tag-c-background: var(--colors-tertiary-900);
  --dvp-tag-c-text: var(--on-surface);
}

.chip--ipz {
  --dvp-tag-c-background: var(--colors-warning-700);
  --dvp-tag-c-text: var(--on-warning-container);
}

.chip--caveat {
  --dvp-tag-c-background: var(--attention-container);
  --dvp-tag-c-text: var(--on-warning-container);
}

.chip--surcharge {
  --dvp-tag-c-background: var(--attention-container);
  --dvp-tag-c-text: var(--on-warning-container);
}

.chip__content {
  background-color: var(--dvp-tag-c-background);
  color: var(--dvp-tag-c-text);
  display: flex;
  flex-direction: row;
  column-gap: var(--fixed-spacing-fix-01);
  justify-content: center;
  align-items: center;
  padding: 0 var(--fixed-spacing-fix-02);
  border-radius: var(--fixed-border-radius-fix-05);
  width: max-content;
  cursor: pointer;
}
</style>
